import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
class Brand {
  static fromProto(proto) {
    let m = new Brand();
    m = Object.assign(m, proto);
    if (proto.group) {
      m.group = Group.fromProto(proto.group);
    }
    if (proto.tabStatuses) {
      m.tabStatuses = TabStatuses.fromProto(proto.tabStatuses);
    }
    if (proto.featureStatuses) {
      m.featureStatuses = FeatureStatuses.fromProto(proto.featureStatuses);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandPath !== 'undefined') {
      toReturn['brandPath'] = this.brandPath;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.group !== 'undefined' && this.group !== null) {
      toReturn['group'] = 'toApiJson' in this.group ? this.group.toApiJson() : this.group;
    }
    if (typeof this.tabStatuses !== 'undefined' && this.tabStatuses !== null) {
      toReturn['tabStatuses'] = 'toApiJson' in this.tabStatuses ? this.tabStatuses.toApiJson() : this.tabStatuses;
    }
    if (typeof this.featureStatuses !== 'undefined' && this.featureStatuses !== null) {
      toReturn['featureStatuses'] = 'toApiJson' in this.featureStatuses ? this.featureStatuses.toApiJson() : this.featureStatuses;
    }
    if (typeof this.activatedVisibilitySources !== 'undefined') {
      toReturn['activatedVisibilitySources'] = this.activatedVisibilitySources;
    }
    return toReturn;
  }
}
class BrandMetadata {
  static fromProto(proto) {
    let m = new BrandMetadata();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.locations) {
      m.locations = parseInt(proto.locations, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.locations !== 'undefined') {
      toReturn['locations'] = this.locations;
    }
    return toReturn;
  }
}
class FeatureStatuses {
  static fromProto(proto) {
    let m = new FeatureStatuses();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requestReviewPageEnabled !== 'undefined') {
      toReturn['requestReviewPageEnabled'] = this.requestReviewPageEnabled;
    }
    if (typeof this.requestReviewCardEnabled !== 'undefined') {
      toReturn['requestReviewCardEnabled'] = this.requestReviewCardEnabled;
    }
    if (typeof this.customerVoiceExecutiveReportEnabled !== 'undefined') {
      toReturn['customerVoiceExecutiveReportEnabled'] = this.customerVoiceExecutiveReportEnabled;
    }
    return toReturn;
  }
}
class ForeignKeys {
  static fromProto(proto) {
    let m = new ForeignKeys();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetBrandRequest {
  static fromProto(proto) {
    let m = new GetBrandRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandPath !== 'undefined') {
      toReturn['brandPath'] = this.brandPath;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    return toReturn;
  }
}
class GetBrandResponse {
  static fromProto(proto) {
    let m = new GetBrandResponse();
    m = Object.assign(m, proto);
    if (proto.brand) {
      m.brand = Brand.fromProto(proto.brand);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brand !== 'undefined' && this.brand !== null) {
      toReturn['brand'] = 'toApiJson' in this.brand ? this.brand.toApiJson() : this.brand;
    }
    return toReturn;
  }
}
class GetLocationsIdsRequest {
  static fromProto(proto) {
    let m = new GetLocationsIdsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    return toReturn;
  }
}
class GetLocationsIdsResponse {
  static fromProto(proto) {
    let m = new GetLocationsIdsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locationIds !== 'undefined') {
      toReturn['locationIds'] = this.locationIds;
    }
    return toReturn;
  }
}
class Group {
  static fromProto(proto) {
    let m = new Group();
    m = Object.assign(m, proto);
    if (proto.path) {
      m.path = Path.fromProto(proto.path);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.path !== 'undefined' && this.path !== null) {
      toReturn['path'] = 'toApiJson' in this.path ? this.path.toApiJson() : this.path;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.members !== 'undefined') {
      toReturn['members'] = this.members;
    }
    return toReturn;
  }
}
class ListBrandsForBusinessRequest {
  static fromProto(proto) {
    let m = new ListBrandsForBusinessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListBrandsForBusinessResponse {
  static fromProto(proto) {
    let m = new ListBrandsForBusinessResponse();
    m = Object.assign(m, proto);
    if (proto.brands) {
      m.brands = proto.brands.map(BrandMetadata.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brands !== 'undefined' && this.brands !== null) {
      toReturn['brands'] = 'toApiJson' in this.brands ? this.brands.toApiJson() : this.brands;
    }
    return toReturn;
  }
}
class ListBrandsMetadataRequest {
  static fromProto(proto) {
    let m = new ListBrandsMetadataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListBrandsMetadataResponse {
  static fromProto(proto) {
    let m = new ListBrandsMetadataResponse();
    m = Object.assign(m, proto);
    if (proto.brands) {
      m.brands = proto.brands.map(BrandMetadata.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brands !== 'undefined' && this.brands !== null) {
      toReturn['brands'] = 'toApiJson' in this.brands ? this.brands.toApiJson() : this.brands;
    }
    return toReturn;
  }
}
class ListGroupsRequest {
  static fromProto(proto) {
    let m = new ListGroupsRequest();
    m = Object.assign(m, proto);
    if (proto.foreignKeys) {
      m.foreignKeys = ForeignKeys.fromProto(proto.foreignKeys);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    if (typeof this.foreignKeys !== 'undefined' && this.foreignKeys !== null) {
      toReturn['foreignKeys'] = 'toApiJson' in this.foreignKeys ? this.foreignKeys.toApiJson() : this.foreignKeys;
    }
    return toReturn;
  }
}
class ListGroupsResponse {
  static fromProto(proto) {
    let m = new ListGroupsResponse();
    m = Object.assign(m, proto);
    if (proto.groups) {
      m.groups = proto.groups.map(Group.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class Path {
  static fromProto(proto) {
    let m = new Path();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nodes !== 'undefined') {
      toReturn['nodes'] = this.nodes;
    }
    return toReturn;
  }
}
class SyncBrandRequest {
  static fromProto(proto) {
    let m = new SyncBrandRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.brandPath !== 'undefined') {
      toReturn['brandPath'] = this.brandPath;
    }
    return toReturn;
  }
}
class TabStatuses {
  static fromProto(proto) {
    let m = new TabStatuses();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewsTabEnabled !== 'undefined') {
      toReturn['reviewsTabEnabled'] = this.reviewsTabEnabled;
    }
    if (typeof this.listingsTabEnabled !== 'undefined') {
      toReturn['listingsTabEnabled'] = this.listingsTabEnabled;
    }
    if (typeof this.socialTabEnabled !== 'undefined') {
      toReturn['socialTabEnabled'] = this.socialTabEnabled;
    }
    if (typeof this.insightsTabEnabled !== 'undefined') {
      toReturn['insightsTabEnabled'] = this.insightsTabEnabled;
    }
    if (typeof this.mapTabEnabled !== 'undefined') {
      toReturn['mapTabEnabled'] = this.mapTabEnabled;
    }
    if (typeof this.advertisingTabEnabled !== 'undefined') {
      toReturn['advertisingTabEnabled'] = this.advertisingTabEnabled;
    }
    if (typeof this.reportTabEnabled !== 'undefined') {
      toReturn['reportTabEnabled'] = this.reportTabEnabled;
    }
    if (typeof this.dataExportTabEnabled !== 'undefined') {
      toReturn['dataExportTabEnabled'] = this.dataExportTabEnabled;
    }
    if (typeof this.websiteTabEnabled !== 'undefined') {
      toReturn['websiteTabEnabled'] = this.websiteTabEnabled;
    }
    if (typeof this.googleQAndATabEnabled !== 'undefined') {
      toReturn['googleQAndATabEnabled'] = this.googleQAndATabEnabled;
    }
    if (typeof this.keywordTrackingTabEnabled !== 'undefined') {
      toReturn['keywordTrackingTabEnabled'] = this.keywordTrackingTabEnabled;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'multi-location-api.vendasta-local.com',
  'test': '',
  'demo': 'multi-location-api-demo.apigateway.co',
  'prod': 'multi-location-api-prod.apigateway.co',
  'production': 'multi-location-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MultiLocationApiService = /*#__PURE__*/(() => {
  class MultiLocationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    syncBrand(r) {
      const request = r.toApiJson ? r : new SyncBrandRequest(r);
      return this.http.post(this._host + "/multilocation.v1.MultiLocation/SyncBrand", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listGroups(r) {
      const request = r.toApiJson ? r : new ListGroupsRequest(r);
      return this.http.post(this._host + "/multilocation.v1.MultiLocation/ListGroups", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGroupsResponse.fromProto(resp)));
    }
    getBrand(r) {
      const request = r.toApiJson ? r : new GetBrandRequest(r);
      return this.http.post(this._host + "/multilocation.v1.MultiLocation/GetBrand", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBrandResponse.fromProto(resp)));
    }
    getLocationIds(r) {
      const request = r.toApiJson ? r : new GetLocationsIdsRequest(r);
      return this.http.post(this._host + "/multilocation.v1.MultiLocation/GetLocationIds", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLocationsIdsResponse.fromProto(resp)));
    }
    listBrandsMetadata(r) {
      const request = r.toApiJson ? r : new ListBrandsMetadataRequest(r);
      return this.http.post(this._host + "/multilocation.v1.MultiLocation/ListBrandsMetadata", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBrandsMetadataResponse.fromProto(resp)));
    }
    listBrandsForBusiness(r) {
      const request = r.toApiJson ? r : new ListBrandsForBusinessRequest(r);
      return this.http.post(this._host + "/multilocation.v1.MultiLocation/ListBrandsForBusiness", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBrandsForBusinessResponse.fromProto(resp)));
    }
  }
  MultiLocationApiService.ɵfac = function MultiLocationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiLocationApiService)();
  };
  MultiLocationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MultiLocationApiService,
    factory: MultiLocationApiService.ɵfac,
    providedIn: 'root'
  });
  return MultiLocationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiLocationService = /*#__PURE__*/(() => {
  class MultiLocationService {
    constructor(api) {
      this.api = api;
    }
    listGroups(groupId, partnerId, marketId = '') {
      const request = {
        groupId,
        foreignKeys: {
          partnerId,
          marketId
        }
      };
      return this.api.listGroups(request).pipe(map(resp => resp.groups));
    }
    getBrand(brandPath) {
      const request = {
        brandPath
      };
      return this.api.getBrand(request).pipe(map(resp => resp.brand));
    }
    getBrandByGroup(groupId) {
      const request = {
        groupId
      };
      return this.api.getBrand(request).pipe(map(resp => resp.brand));
    }
    listBrandsMetadata(partnerId) {
      return this.api.listBrandsMetadata({
        partnerId: partnerId
      }).pipe(map(resp => resp.brands));
    }
    listBrandsForBusiness(partnerId, businessId) {
      return this.api.listBrandsForBusiness({
        partnerId,
        businessId
      }).pipe(map(resp => resp.brands));
    }
  }
  MultiLocationService.ɵfac = function MultiLocationService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiLocationService)(i0.ɵɵinject(MultiLocationApiService));
  };
  MultiLocationService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MultiLocationService,
    factory: MultiLocationService.ɵfac,
    providedIn: 'root'
  });
  return MultiLocationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, Brand, BrandMetadata, FeatureStatuses, ForeignKeys, GetBrandRequest, GetBrandResponse, GetLocationsIdsRequest, GetLocationsIdsResponse, Group, ListBrandsForBusinessRequest, ListBrandsForBusinessResponse, ListBrandsMetadataRequest, ListBrandsMetadataResponse, ListGroupsRequest, ListGroupsResponse, MultiLocationService, Path, SyncBrandRequest, TabStatuses };
